import { render, staticRenderFns } from "./ConcessionEdit.vue?vue&type=template&id=583f1363&scoped=true&"
import script from "./ConcessionEdit.vue?vue&type=script&lang=js&"
export * from "./ConcessionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f1363",
  null
  
)

export default component.exports